"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NovageSkincareAdvisorController = void 0;
var _auth = require("@ori/auth");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _presentationHttp = require("@ori/presentation-http");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constantsGenerated = require("../constants-generated");
var _contexts = require("../contexts");
var _logger2 = require("../logger");
var _ApiProvider = require("./ApiProvider");
var _FoundationFinder = require("./FoundationFinder");
var _SkinDiagnosis = require("./SkinDiagnosis");
var _VirtualTryOn = require("./VirtualTryOn");
var _VirtualTryOnPDP = require("./VirtualTryOnPDP");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file @preserve -- controller */

/**
 * Accepts config data, renders NovageSkincareAdvisor.
 */
const NovageSkincareAdvisorController = ({
  translations
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    customerId,
    token
  } = (0, _auth.useToken)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
    fallback: null,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
      team: _testidGenerator.Team.Presentation,
      project: _constantsGenerated.APP_NAME,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
          areaName: "NovageSkincareAdvisorController",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ApiProvider.ApiProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationHttp.HeadersProvider, {
              customerId: customerId,
              language: language,
              sourceAppName: _constantsGenerated.PACKAGE_NAME,
              tenant: tenant,
              token: token,
              children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_contexts.NovageSkincareAdvisorProvider, {
                translations: translations,
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SkinDiagnosis.SkinDiagnosis, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FoundationFinder.FoundationFinder, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VirtualTryOn.VirtualTryOn, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VirtualTryOnPDP.VirtualTryOnPDP, {})]
              })
            })
          })
        })
      })
    })
  });
};
exports.NovageSkincareAdvisorController = NovageSkincareAdvisorController;